/**
 * Created by Administrator on 2018/6/6.
 */
const state = {
  isLoading: false
}
const mutations = {
  changeLoading: function (state, param) {
    state.isLoading = param
  }
}
const actions = {}
export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/loading.js